export const studyScheduleWeeksDefaults = {
  firstWeekIndex: 1,
  displayedNumOfWeeks: 3,
  weeksIntoStudyOffset: 2, // to add extra "current & next" weeks
};
